import { render } from "./BeneficiaryPayment.vue?vue&type=template&id=27bff5da"
import script from "./BeneficiaryPayment.vue?vue&type=script&lang=js"
export * from "./BeneficiaryPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__